import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'
import { TRIAL_STAFF_TYPE_ENUM, UserTypes } from '../Types'

export const useMe = (projectId?: string) => {
  const path: string | null =
    projectId && projectId !== undefined && projectId !== 'undefined' ? ENDPOINTS.PROJECTS.GET_ME(projectId) : null

  const { data, error, mutate } = useSWR(path, getReq, { suspense: true })

  console.log('useMe > data.data = ', data)
  const userType: TRIAL_STAFF_TYPE_ENUM | Extract<UserTypes, 'CLINICIAN'> = !data ? data : data.data.type

  return {
    data: !data ? data : data.data,
    userType: userType,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
